import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NgxSpinnerComponent } from "ngx-spinner";
import { filter, Observable } from 'rxjs';
import { BackendHealth } from './core/models/health-status.model';
import { HealthService } from './core/services/health.service';
import { VersionCheckService } from './core/services/version-check.service';

@Component({
  selector: 'kt-app-root',
  imports: [RouterOutlet, NgxSpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'All-In-One Invoice';

  private router = inject(Router);
  backends$!: Observable<BackendHealth[]>;

  private healthService = inject(HealthService);
  private versionCheckService = inject(VersionCheckService);

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        // wait for Angular to finish rendering the route
        setTimeout(async () => {
          const AOS = await import('aos');
          AOS.default.refreshHard();
        }, 0);
      });
  }

  ngOnInit(): void {
    // triggers once; subsequent calls reuse cached observable
    this.healthService.checkAllOnce().subscribe();
    this.backends$ = this.healthService.health$;
    // In production, periodically check for new deploy and reload if needed (e.g. mobile cache)
    this.versionCheckService.start();
  }

  trackByName(_: number, item: BackendHealth) {
    return item.name;
  }
}
